import styled, { css } from "styled-components";
import { MAX_WIDTH_MOBILE_NAV } from "./Navigation";
import { Subheader } from "./Subheader";
import type { DefaultTheme } from "styled-components";

export const containerStyles = css`
  padding: 0 50px;
  margin: 0 auto;

  @media (max-width: ${MAX_WIDTH_MOBILE_NAV}px) {
    padding: 0 32px;
  }
`;

export const Container = styled.div`
  ${containerStyles}
  max-width: 1500px;
`;

export const ColoredSection = styled.section`
  background: ${(props) => props.theme.contentment}4d; // 30% opacity
`;

export const SectionInner = styled.div`
  padding: 56px 0 91px;

  ${Subheader} {
    margin-bottom: 0.82em;
  }

  @media (max-width: 960px) {
    padding: 32px 0 56px;

    ${Subheader} {
      margin-bottom: 0.5em;
    }
  }
`;

export const Divider = styled.hr<{ color?: keyof DefaultTheme }>`
  border: none;
  border-bottom: 3px solid
    ${(props) => props.theme[props.color ?? "excitement"]};
  margin: 0;
`;

export const InlineLink = styled.a`
  color: #5f748c;
  text-decoration: underline;
`;
